var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileTxtBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Canvas",
    transform: "translate(10353 -935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__file-txt-bw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__file-txt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Canvas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__txt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt-bw_svg__file-txt-bw_svg__path0_fill",
    transform: "translate(-10353 935)",
    fill: "#D9DEE0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt-bw_svg__file-txt-bw_svg__path1_fill",
    transform: "translate(-10337.3 978.645)",
    fill: "#FFFFFF"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Group_2_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10332.4 959.146L -10313.4 959.146L -10313.4 960.871L -10332.4 960.871L -10332.4 959.146Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt-bw_svg__file-txt-bw_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -10332.4 960.871)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10332.4 962.595L -10313.4 962.595L -10313.4 964.319L -10332.4 964.319L -10332.4 962.595Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt-bw_svg__file-txt-bw_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -10332.4 964.319)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10341 966.043L -10313.4 966.043L -10313.4 967.768L -10341 967.768L -10341 966.043Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt-bw_svg__file-txt-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10341 967.768)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10341 969.492L -10320.3 969.492L -10320.3 971.216L -10341 971.216L -10341 969.492Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt-bw_svg__file-txt-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10341 971.216)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__T"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt-bw_svg__file-txt-bw_svg__path5_fill",
    transform: "translate(-10341 955.696)",
    fill: "#D9DEE0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10332.4 955.693L -10313.4 955.693L -10313.4 957.418L -10332.4 957.418L -10332.4 955.693Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file-txt-bw_svg__file-txt-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt-bw_svg__file-txt-bw_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -10332.4 957.418)",
    fill: "#FFFFFF"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-txt-bw_svg__file-txt-bw_svg__path0_fill",
    d: "M 35.7148 0L 3.57078 0C 1.60081 0 -1.60235e-16 1.55103 -1.60235e-16 3.46966L -1.60235e-16 58.5993C -1.60235e-16 60.5159 1.60081 62.069 3.57078 62.069L 46.4293 62.069C 48.4034 62.069 50 60.5159 50 58.5993L 50 13.8786L 35.7148 0ZM 35.7148 4.90552L 44.9512 13.8786L 35.7148 13.8786L 35.7148 4.90552ZM 46.43 58.5993L 3.57078 58.5993L 3.57078 3.46966L 32.1433 3.46966L 32.1433 13.8786C 32.1433 15.7952 33.7405 17.3483 35.7141 17.3483L 46.4293 17.3483L 46.4293 58.5993L 46.43 58.5993Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt-bw_svg__file-txt-bw_svg__path1_fill",
    d: "M 6.03103 1.80869e-08C 6.17586 1.80869e-08 6.2931 0.0482759 6.38276 0.144828C 6.47931 0.234483 6.52759 0.351724 6.52759 0.496552C 6.52759 0.641379 6.47931 0.762069 6.38276 0.858621C 6.2931 0.948276 6.17586 0.993103 6.03103 0.993103L 3.8069 0.993103L 3.8069 7.54138C 3.8069 7.6931 3.75517 7.82069 3.65172 7.92414C 3.54828 8.02759 3.42069 8.07931 3.26897 8.07931C 3.11724 8.07931 2.98966 8.02759 2.88621 7.92414C 2.78276 7.82069 2.73103 7.6931 2.73103 7.54138L 2.73103 0.993103L 0.496552 0.993103C 0.351724 0.993103 0.231034 0.948276 0.134483 0.858621C 0.0448276 0.762069 6.166e-09 0.641379 6.166e-09 0.496552C 6.166e-09 0.351724 0.0448276 0.234483 0.134483 0.144828C 0.231034 0.0482759 0.351724 1.80869e-08 0.496552 1.80869e-08L 6.03103 1.80869e-08ZM 13.4807 7.21034C 13.5566 7.32069 13.5945 7.43793 13.5945 7.56207C 13.5945 7.7 13.5497 7.82069 13.46 7.92414C 13.3703 8.02759 13.2497 8.07931 13.0979 8.07931C 12.9255 8.07931 12.7876 8.01379 12.6841 7.88276L 10.4393 4.76897L 8.06 7.92414C 7.95655 8.02759 7.83241 8.07931 7.68759 8.07931C 7.53586 8.07931 7.41517 8.03103 7.32552 7.93448C 7.24276 7.83793 7.20138 7.72069 7.20138 7.58276C 7.20138 7.44483 7.24276 7.32069 7.32552 7.21034L 9.73586 4.00345L 7.46 0.848276C 7.39103 0.758621 7.35655 0.651724 7.35655 0.527586C 7.35655 0.382759 7.40138 0.258621 7.49103 0.155172C 7.58069 0.0517242 7.70138 1.80869e-08 7.8531 1.80869e-08C 8.03241 1.80869e-08 8.16 0.0517242 8.23586 0.155172L 10.46 3.23793L 12.7772 0.155172C 12.8738 0.0517242 13.0014 1.80869e-08 13.16 1.80869e-08C 13.3048 1.80869e-08 13.4186 0.0482759 13.5014 0.144828C 13.591 0.241379 13.6359 0.358621 13.6359 0.496552C 13.6359 0.613793 13.5979 0.731034 13.5221 0.848276L 11.1634 3.9931L 13.4807 7.21034ZM 20.2753 1.80869e-08C 20.4202 1.80869e-08 20.5374 0.0482759 20.6271 0.144828C 20.7236 0.234483 20.7719 0.351724 20.7719 0.496552C 20.7719 0.641379 20.7236 0.762069 20.6271 0.858621C 20.5374 0.948276 20.4202 0.993103 20.2753 0.993103L 18.0512 0.993103L 18.0512 7.54138C 18.0512 7.6931 17.9995 7.82069 17.896 7.92414C 17.7926 8.02759 17.665 8.07931 17.5133 8.07931C 17.3616 8.07931 17.234 8.02759 17.1305 7.92414C 17.0271 7.82069 16.9754 7.6931 16.9754 7.54138L 16.9754 0.993103L 14.7409 0.993103C 14.5961 0.993103 14.4754 0.948276 14.3788 0.858621C 14.2892 0.762069 14.2443 0.641379 14.2443 0.496552C 14.2443 0.351724 14.2892 0.234483 14.3788 0.144828C 14.4754 0.0482759 14.5961 1.80869e-08 14.7409 1.80869e-08L 20.2753 1.80869e-08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt-bw_svg__file-txt-bw_svg__path2_fill",
    d: "M 0 0L 18.9654 0L 18.9654 1.72463L 0 1.72463L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt-bw_svg__file-txt-bw_svg__path3_fill",
    d: "M 0 0L 27.5861 0L 27.5861 1.72463L 0 1.72463L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt-bw_svg__file-txt-bw_svg__path4_fill",
    d: "M 0 0L 20.6896 0L 20.6896 1.72463L 0 1.72463L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt-bw_svg__file-txt-bw_svg__path5_fill",
    d: "M 6.89652 0L 6.89652 1.5269L 4.34931 1.5269L 4.34931 8.62317L 2.55876 8.62317L 2.55876 1.5269L 0 1.5269L 0 0L 6.89652 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTxtBw);
export default __webpack_public_path__ + "static/media/file-txt-bw.48138fbafc6382c74c8ddb044466fc0e.svg";
export { ForwardRef as ReactComponent };